import * as React from "react";
import Svg, { Path } from "react-native-svg";

const AttachIcon = (props) => (
  <Svg
    width={28}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M21.023 6.025A4.7 4.7 0 0 0 14.42 6l-7.77 7.635a1.169 1.169 0 0 1-1.9-.388 1.16 1.16 0 0 1 .262-1.266l7.768-7.633a7.04 7.04 0 0 1 9.893.03 6.97 6.97 0 0 1 0 9.887L12.565 24.332a4.588 4.588 0 0 1-6.468 0 4.543 4.543 0 0 1 0-6.442l9.427-9.387a1.169 1.169 0 0 1 1.9.376 1.158 1.158 0 0 1-.253 1.266l-9.424 9.387a2.226 2.226 0 0 0 0 3.157 2.247 2.247 0 0 0 3.173 0l10.103-10.066a4.653 4.653 0 0 0 0-6.598Z"
      fill={props.color}
    />
  </Svg>
);
AttachIcon.defaultProps = {
  color: "#888",
};
export default AttachIcon;
